import { Injectable, OnDestroy } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class SwipeRefreshManagerService implements OnDestroy {
  private _activeComponents = new Set<any>();
  private _destroyed$ = new Subject<void>();
  private _currentUrl: string;

  constructor(private readonly router: Router) {
    this._currentUrl = this.router.url;

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this._destroyed$)
      )
      .subscribe((event: NavigationEnd) => {
        const previousUrl = this._currentUrl;
        this._currentUrl = event.urlAfterRedirects;

        // Extract base paths without query params or fragments
        const getBasePath = (url: string) => {
          return url.split(/[?#]/)[0];
        };

        const previousBasePath = getBasePath(previousUrl);
        const currentBasePath = getBasePath(this._currentUrl);

        // Only disconnect if we're actually navigating to a different route (not just changing fragment/query)
        if (previousBasePath !== currentBasePath) {
          this.disconnectAll();
        }
      });
  }

  registerComponent(component: any): void {
    this._activeComponents.add(component);
  }

  unregisterComponent(component: any): void {
    this._activeComponents.delete(component);
  }

  private disconnectAll(): void {
    this._activeComponents.forEach(component => {
      if (component.disconnect) {
        component.disconnect();
      }
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
